export const UNITS = {
  sales: '만원',
  audi: '명',
};
